import template from './project-group-modal.pug';

export const ProjectGroupModalComponent = {
  template,
  bindings:{
    resolve: '<',
    modalInstance: '<',
  },
  controller: class ProjectGroupModalComponent {
    constructor($async, $log, Project, AlertBox) {
      'ngInject';
      this.Project = Project;
      this.AlertBox = AlertBox;
      this.$log = $log;
      this.save = $async(this.save.bind(this));
    }

    $onInit() {
      this.group = this.resolve.group || {};
    }

    async save({ group }) {
      try {
        if (group.id) {
          const resp =  await this.Project.updateGroup(group);
          this.modalInstance.close(resp);
          this.AlertBox.addMessage('alert.updated', { type: 'success' });
        } else {
          const resp = await this.Project.createGroup(group);
          this.modalInstance.close(resp);
        }
      } catch (e) {
        this.$log.error(e);
      }
    }

    close() {
      this.modalInstance.close(void(0));
    }

  }
};
